import React from "react";
import { ArrowRight } from "lucide-react";
import { NLink } from "@/i18n/I18nProvider";
import { Heading } from "@/components/about/AboutSections";

const num = (i) => String(i + 1).padStart(2, "0");

const ServiceGrid = ({ items }) => (
  <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0F1B2D]/10">
    {items.map((s, i) => (
      <div key={s.t} data-testid={`about-service-${i}`} className="bg-white p-8 lg:p-10 min-h-[200px] flex flex-col hover:bg-[#F4F0E8]/60 transition-colors">
        <div className="font-display text-[#C4A46A] text-sm">{num(i)}</div>
        <h3 className="mt-4 font-display text-xl text-[#0F1B2D] tracking-tight">{s.t}</h3>
        <p className="mt-3 text-[#5E6470] text-sm leading-relaxed">{s.d}</p>
      </div>
    ))}
  </div>
);

const FutureServices = ({ title, items }) => (
  <div className="mt-20">
    <div className="overline text-[#5E6470]">{title}</div>
    <span className="gold-rule mt-3 block" />
    <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#0F1B2D]/10">
      {items.map((s, i) => (
        <div key={s.t} data-testid={`about-future-service-${i}`} className="bg-[#F4F0E8]/50 p-8">
          <div className="font-display text-[#C4A46A] text-sm">{num(i)}</div>
          <h4 className="mt-3 font-display text-lg text-[#0F1B2D] tracking-tight">{s.t}</h4>
          <p className="mt-3 text-[#5E6470] text-[13px] leading-relaxed">{s.d}</p>
        </div>
      ))}
    </div>
  </div>
);

const FeaturedPrograms = ({ items }) => (
  <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0F1B2D]/10">
    {items.map((p, i) => (
      <NLink
        key={p.slug}
        to={`/${p.slug}`}
        data-testid={`about-featured-${p.slug}`}
        className="bg-white p-10 lg:p-12 flex flex-col min-h-[280px] hover:bg-[#F4F0E8]/60 transition-colors group"
      >
        <div className="font-display text-[#C4A46A] text-sm">{num(i)}</div>
        <h3 className="mt-6 font-display text-2xl lg:text-3xl text-[#0F1B2D] tracking-tight leading-snug">{p.t}</h3>
        <span className="gold-rule mt-4 block" />
        <p className="mt-6 text-[#5E6470] text-[15px] leading-relaxed">{p.d}</p>
        <span className="mt-auto pt-8 inline-flex items-center gap-3 text-[#0F1B2D] text-[11px] tracking-[0.24em] uppercase font-bold">
          <span className="border-b border-[#C4A46A] pb-1 group-hover:text-[#C4A46A] transition-colors">{p.cta}</span>
          <ArrowRight size={14} className="text-[#C4A46A]" />
        </span>
      </NLink>
    ))}
  </div>
);

export const AboutServices = ({ s }) => (
  <section id="services" className="bg-white scroll-mt-28" data-testid="about-services">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <Heading kicker={s.kicker} title={s.title} kickerClass="text-[#C4A46A]" />
      <ServiceGrid items={s.items} />
      {s.future && <FutureServices title={s.futureT} items={s.future} />}
      {s.featured && <FeaturedPrograms items={s.featured} />}
    </div>
  </section>
);
